//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricAnalysis.js";
import "../no/Builder.js";
import "../GeometricUtilities/GeometricUtilities.CombOptionsBuilder.js";
import "../GeometricUtilities/GeometricUtilities.CurveRangeBuilder.js";
import "../no/ScCollector.js";
import "../no/GeometricUtilities.js";
import "../no/ScCollector.js";
let d=[[[1,"CombOptions",0,"GeometricUtilities.CombOptionsBuilder",0],[1,"CombRange",0,"GeometricUtilities.CurveRangeBuilder",0],[0,"DynamicProjection",1,0],[0,"Method",1,0],[0,"Projection",1,0],[0,"ReverseDirection",1,0],[1,"SelectedCurves",0,"ScCollector",0],[0,"ShowCombs",1,0],[0,"ShowInflections",1,0],[0,"ShowMaxLabels",1,0],[0,"ShowMinLabels",1,0],[0,"ShowPeaks",1,0],[0,"Style",1,0],[0,"Vector",1,"Direction",0],[0,"Xyz",1,0]],[[[],"UpdateWorkView",{},0,0],[["pointCount"],"CreateDumbPeakPoints",{R_:{pointArray:"Point[]"}},0,0],[["pointCount"],"CreateDumbInflectionPoints",{R_:{pointArray:"Point[]"}},0,0],[["index"],"GetCurveRange",{R_:{combRange:"GeometricUtilities.CurveRangeBuilder"}},1,0],[[],"GetCurveRangeListLength",{R_:{length:''}},0,0]],[]];
SPLM.GeometricAnalysis.CurveCurvatureAnalysisBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricAnalysis.CurveCurvatureAnalysisBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricAnalysis.CurveCurvatureAnalysisBuilder.ProjectionTypes = Object.freeze({
    "None" : "None", "CurvePlane" : "CurvePlane", "Vector" : "Vector", "View" : "View", "Xyz" : "Xyz"});

SPLM.GeometricAnalysis.CurveCurvatureAnalysisBuilder.XyzTypes = Object.freeze({
    "X" : "X", "Y" : "Y", "Z" : "Z"});

SPLM.GeometricAnalysis.CurveCurvatureAnalysisBuilder.LabelValues = Object.freeze({
    "Curvature" : "Curvature", "RadiusofCurvature" : "RadiusofCurvature"});

SPLM.GeometricAnalysis.CurveCurvatureAnalysisBuilder.NeedleDirection = Object.freeze({
    "Inside" : "Inside", "Outside" : "Outside"});

SPLM.GeometricAnalysis.CurveCurvatureAnalysisBuilder.CalculationMethod = Object.freeze({
    "Curvature" : "Curvature", "RadiusofCurvature" : "RadiusofCurvature"});

SPLM.GeometricAnalysis.CurveCurvatureAnalysisBuilder.DisplayStyle = Object.freeze({
    "Linear" : "Linear", "Logarithmic" : "Logarithmic"});

export default SPLM;